import React, {
  useRef,
  useMemo,
  useState,
  useCallback,
  ReactNode,
} from "react";
import { withRouter } from "react-router-dom";

import {
  ActionToolbar,
  DialogWithActions,
  EditButton,
  GqlTable,
} from "../../components";

import { Button, Container } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";

import { QUERIES } from "../../../graphql";
import {
  CommunicationGroup,
  CommunicationGroupData,
} from "../../../graphql/models";
import { CommunicationGroupForm } from "./communication_group_form";

import useCommunicationGroupsStyle from "./communication_groups.style";
import { ColorButton, createColor } from "material-ui-color";
//import { useUserState } from '../../../context';

function CommunicationGroupsPage(props: any) {
  const classes = useCommunicationGroupsStyle();

  const tableRef = useRef();

  //const { userRole } = useUserState();
  const [formDialogOpened, setFormDialogOpened] = useState(false);
  const [formCommunicationGroup, setFormCommunicationGroup] = useState<
    CommunicationGroup | CommunicationGroupData | undefined
  >(void 0);

  const addNewCommunicationGroup = () => {
    setFormCommunicationGroup({} as CommunicationGroup);
    setFormDialogOpened(true);
  };

  const editCommunicationGroup = (row) => {
    setFormCommunicationGroup({
      ...row,
    });
    setFormDialogOpened(true);
  };

  const onValueUpdatedSuccessfully = () => {
    setFormCommunicationGroup(void 0);
    setFormDialogOpened(false);
    (tableRef as any).current?.refresh();
  };

  const gqlTableRowActions = useCallback((row) => {
    const actions: ReactNode[] = [];
    actions.push(
      <EditButton
        key="editCommunicationGroup"
        onClick={() => editCommunicationGroup(row)}
      />
    );

    return actions;
  }, []);

  const actionToolbarActions = useMemo(() => {
    const actions: any[] = [];
    actions.push(
      <Button
        key="addNewCommunicationGroup"
        variant="contained"
        color="primary"
        onClick={() => addNewCommunicationGroup()}
      >
        Aggiungi Nuovo
      </Button>
    );
    return actions;
  }, []);

  return (
    <Container className={classes.container} maxWidth={false} component="div">
      <>
        <ActionToolbar
          title={"Gruppi di comunicazione"}
          actions={actionToolbarActions}
        />
        <GqlTable
          ref={tableRef}
          columns={["", "Nome", "Colore", "Descrizione", "Appartamenti"].map(
            (v, index) => (
              <TableCell key={index}>{v}</TableCell>
            )
          )}
          query={QUERIES.COMMUNICATION_GROUPS}
          queryResultDataField="communicationGroups"
          rows={(row) => (
            <>
              <TableCell>{gqlTableRowActions(row)}</TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell>
                <ColorButton color={createColor(row.color)} />
              </TableCell>
              <TableCell>{row.description}</TableCell>
              <TableCell>
                {row.apartments.map((a) => a.code).join(", ")}
              </TableCell>
            </>
          )}
        />
        <DialogWithActions
          fullScreen
          open={formDialogOpened}
          setOpen={setFormDialogOpened}
          title={"Aggiungi / Modifica Gruppo"}
        >
          <CommunicationGroupForm
            value={formCommunicationGroup}
            onValueUpdatedSuccessfully={onValueUpdatedSuccessfully}
          />
        </DialogWithActions>
      </>
    </Container>
  );
}

export default withRouter(CommunicationGroupsPage);
